/**
 * Tokens de diseño (sincronizados con Tailwind config y MUI theme).
 *
 * Los valores por defecto son los del base. Los proyectos derivados
 * generados con Cookiecutter pueden sobrescribir los primarios.
 */
export const designTokens = {
  colors: {
    primary: {
      DEFAULT: '#0d6efd',
      hover: '#0b5ed7',
      light: '#e8f0fe',
    },
    secondary: {
      DEFAULT: '#0ea5e9',
      hover: '#0284c7',
      light: '#e0f2fe',
      darkText: '#0c4a6e',
    },
    success: {
      DEFAULT: '#2e7d32',
      light: '#e8f5e9',
    },
    error: {
      DEFAULT: '#d32f2f',
      light: '#fce4ec',
    },
    warning: {
      DEFAULT: '#f57c00',
      light: '#fff3e0',
    },
    text: {
      body: '#333',
      heading: '#222',
      muted: '#888',
    },
    bg: {
      layout: '#f5f6fa',
      darkLayout: '#0F172A',
    },
    border: {
      sutil: '#e0e0e0',
    },
  },
  spacing: {
    sidebarWidth: 260,
    sidebarCollapsedWidth: 64,
    headerHeight: 60,
  },
  radius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
  },
  shadow: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 25px rgba(0,0,0,0.15)',
    authCard: '0 20px 60px rgba(0,0,0,0.15)',
  },
  zIndex: {
    header: 40,
    sidebar: 50,
    modalBackdrop: 60,
    modal: 70,
    drawerBackdrop: 80,
    drawer: 90,
    toast: 9999,
  },
  typography: {
    fontFamily: 'Inter, system-ui, sans-serif',
    h1: '1.75rem',
    h2: '1.5rem',
    h3: '1.25rem',
    h4: '1.125rem',
    body1: '1rem',
    body2: '0.875rem',
    caption: '0.75rem',
    label: '0.8125rem',
  },
} as const;

export type DesignTokens = typeof designTokens;
